import React from 'react'
import { Box, Stack } from '@mantine/core'
import ItemWrapper from '../../../components/ItemWrapper'
import LabeledTitle from '../../../components/LabeledTitle'
import ExpandableListWrapper from '../../../components/ExpandableListWrapper'
import RelatedCompanyCard from './RelatedCompanyCard'
import { RelatedCompanyItem } from './types'

interface RelatedCompaniesListProps {
  companies: RelatedCompanyItem[]
}

const RelatedCompaniesList: React.FC<RelatedCompaniesListProps> = ({ companies }) => {
  const cardBackgroundColor = '#ffffff'

  return (
    <ItemWrapper>
      <LabeledTitle title="关联企业详情" />
      <Stack gap="md">
        <ExpandableListWrapper isEmpty={companies.length === 0}>
          {companies.map((company) => (
            <Box
              key={company.id}
              p="md"
              style={{
                backgroundColor: cardBackgroundColor,
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                border: '1px solid rgba(0,0,0,0.05)',
              }}
            >
              <RelatedCompanyCard company={company} />
            </Box>
          ))}
        </ExpandableListWrapper>
      </Stack>
    </ItemWrapper>
  )
}

export default RelatedCompaniesList
